var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeInvestorLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 65V49l-9 16h9zM23 62V48l-8 14h8z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.833 32.5V18h19.978C71.02 18 72 19.229 72 20.74V65H59",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.539 36H68v-5H55.539C54.69 31 54 32.122 54 33.5s.683 2.5 1.539 2.5z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.77 47H68v-5h-6.23c-.425 0-.77 1.122-.77 2.5s.342 2.5.77 2.5z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.23 41H13v-5h6.23c.424 0 .77 1.122.77 2.5s-.341 2.5-.77 2.5z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.77 58H68v-5h-6.23c-.425 0-.77 1.122-.77 2.5s.342 2.5.77 2.5zM23 49v18h32V49M9 36v26h11.5",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 49l21.759-20L60 49M5 35l18.133-17L34 29",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 52,
    r: 10,
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.203 54.883a.961.961 0 00-.626 1.818l.626-1.818zm1.52 1.221l.006-.96h-.005v.96zm2.168-1.524l.947.163-.947-.163zm-.648-1.76l.613-.74-.002-.002-.611.742zm-1.793-.566l-.18.944.007.001.173-.945zm-1.402-.691l-.741.61.004.006.737-.617zm-.412-1.52l-.947-.163v.006l.947.157zm2.168-1.524l-.003.96.003-.96zm1.499 1.213a.96.96 0 10.668-1.802l-.668 1.802zm-3.413 6.06l-.312.909h.002l.005.002a1.043 1.043 0 00.052.017c.034.011.08.026.138.043.115.033.277.078.47.122.38.087.916.18 1.478.18l.001-1.922c-.366 0-.747-.063-1.052-.132a6.076 6.076 0 01-.447-.12l-.02-.007-.004-.001h.001l-.312.909zm1.828 1.273a3.552 3.552 0 001.877-.525c.585-.367 1.1-.964 1.243-1.797l-1.894-.327c-.032.185-.144.354-.37.496-.238.15-.554.233-.845.231l-.01 1.922zm3.12-2.322a2.846 2.846 0 00-.982-2.663l-1.227 1.48c.245.203.37.538.315.856l1.894.327zm-.984-2.665c-.404-.333-.855-.492-1.236-.586-.34-.084-.775-.143-.995-.183l-.346 1.89c.39.072.604.09.882.16.239.058.379.125.473.203l1.222-1.483zm-2.223-.768c-.477-.091-.717-.21-.846-.364l-1.474 1.233c.578.691 1.392.91 1.958 1.019l.362-1.888zm-.841-.359a.966.966 0 01-.206-.75l-1.896-.315c-.135.811.1 1.659.619 2.288l1.483-1.223zm-.207-.744c.049-.28.16-.424.297-.518.16-.11.446-.211.92-.21l.007-1.921c-.727-.003-1.437.149-2.017.548-.602.415-.973 1.035-1.1 1.774l1.893.327zm1.218-.727a4.9 4.9 0 011.487.247l.017.006h0-.002v-.001l.334-.901.334-.901h-.001l-.002-.001a.178.178 0 00-.005-.002l-.013-.005-.04-.014a6.789 6.789 0 00-.597-.168 6.816 6.816 0 00-1.506-.182L38.8 49.48z",
    fill: "#7E776E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.956 56.732l.001 1.693M38.973 46.106l-.004 1.649",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgHomeInvestorLoan;